import React from "react";
import { Admin, ListProps, Resource, useRedirect } from "react-admin";
import dataProvider from "reactAdmin/dataProvider";
import authProvider, { isAuthorized } from "./reactAdmin/authProvider";
import { UserList } from "reactAdmin/resource/user/userList";
import { UserEdit } from "reactAdmin/resource/user/userEdit";
import UserIcon from "@material-ui/icons/Group";
import { QueryClient, QueryClientProvider } from "react-query";
import { AdminResource } from "reactAdmin/resource/resource";
import { Capability } from "reactAdmin/capabilities";
import reducer from "store/auth/reducer";
import { Provider } from 'react-redux';
import { store } from "store";
import { history } from "store/history";
import { UserCreate } from "reactAdmin/resource/user/userCreate";
import BusinessIcon from '@material-ui/icons/Business';
import { OrganizationList } from "reactAdmin/resource/organization/organizationList";
import { OrganizationCreate } from "reactAdmin/resource/organization/organizationCreate";
import { OrganizationEdit } from "reactAdmin/resource/organization/organizationEdit";
import AlbumIcon from '@material-ui/icons/Album';
import { ResultCreate } from "reactAdmin/resource/result/resultCreate";
import { ResultEdit } from "reactAdmin/resource/result/resultEdit";
import UserLogin from "reactAdmin/resource/user/userLogin";
import Layout from "components/layout/layout";
import { useTranslation } from "react-i18next";
import customRoutes from "reactAdmin/customRoutes";

const queryClient = new QueryClient();

function App() {
  const { t } = useTranslation();

  return (
    <QueryClientProvider client={queryClient}>
      <Provider store={store}>
        <Admin
          authProvider={authProvider}
          dataProvider={dataProvider}
          history={history}
          customReducers={{
              auth: reducer,
          }}
          layout={Layout}
          customRoutes={customRoutes}
          loginPage={UserLogin}
        >
          {async (isAuthorized: isAuthorized) => isAuthorized(Capability.ACCESS_RESOURCES) ? [
            <Resource
              name={AdminResource.users}
              icon={UserIcon}
              list={isAuthorized(Capability.LIST_USERS) && (isAuthorized(Capability.INVITE_USER) || isAuthorized(Capability.UPDATE_USER)) ? UserList : undefined}
              create={isAuthorized(Capability.INVITE_USER) ? UserCreate : undefined}
              edit={isAuthorized(Capability.UPDATE_USER) ? UserEdit : undefined}
              options={{label: t('resource.users')}}
            />,
            <Resource
              name={AdminResource.organizations}
              icon={BusinessIcon}
              list={isAuthorized(Capability.LIST_ORGANIZATIONS) && !isAuthorized(Capability.MANAGE_ORGANIZATION) && (isAuthorized(Capability.CREATE_ORGANIZATION) || isAuthorized(Capability.UPDATE_ORGANIZATION)) ? OrganizationList : undefined}
              create={isAuthorized(Capability.CREATE_ORGANIZATION) ? OrganizationCreate : undefined}
              edit={isAuthorized(Capability.UPDATE_ORGANIZATION) ? OrganizationEdit : undefined}
              options={{label: t('resource.organizations')}}
            />,
            <Resource
              name={AdminResource.results}
              icon={AlbumIcon}
              list={undefined}
              create={isAuthorized(Capability.CREATE_RESULT) ? ResultCreate : undefined}
              edit={isAuthorized(Capability.UPDATE_RESULT) ? ResultEdit : undefined}
            />,
          ] : [
              // Workaround - at least one resource has to be register
              <Resource name={'users'} list={List} />,
          ]}
        </Admin>
      </Provider>
    </QueryClientProvider>
  );
}

export const List = (props: ListProps) => {
    const redirect = useRedirect();
    redirect('/login')
    return null;
}

export default App;
